// Регистрация. Получить код
export const REGISTRATION = "REGISTRATION";

// Проверяем код подтверждения
export const CONFIRMATION_CODE = "CONFIRMATION_CODE";

//  Увеличить количество попыток (attempts)
export const INCREASE_ATTEMPTS = "INCREASE_ATTEMPTS";

// Номер телефона
export const PHONE_NUMBER = "PHONE_NUMBER";
